import React, { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SectionContext = /*#__PURE__*/React.createContext(undefined);
export const SectionMetaProvider = ({
  children,
  ...rest
}) => {
  const {
    sectionId,
    representationName
  } = 'representationName' in rest ? rest : {
    sectionId: rest.section.id,
    representationName: rest.section.representation.name
  };
  const {
    sectionTitle
  } = 'section' in rest && 'title' in rest.section.representation ? {
    sectionTitle: rest.section.representation.title
  } : {
    sectionTitle: undefined
  };
  const [state] = useState({
    sectionId,
    representationName,
    sectionTitle
  });
  return /*#__PURE__*/_jsx(SectionContext.Provider, {
    value: state,
    children: children
  });
};
export const useSectionMeta = () => {
  const context = React.useContext(SectionContext);
  if (context === undefined) {
    return {
      sectionId: undefined,
      representationName: undefined,
      sectionTitle: undefined
    };
  }
  return context;
};